import { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Search } from 'lucide-react'
import { SITE_NAME, SITE_URL } from '../utils/seo.js'

const title = `Search – ${SITE_NAME}`
const description = `Search FastAudio for conversion guides, FAQs, and supported platforms.`
const canonical = `${SITE_URL}/query`

export default function Query() {
  const [q, setQ] = useState('')

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
        <meta name="robots" content="noindex,follow" />
      </Helmet>

      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-16 md:py-24 text-center">
        <h1 className="text-2xl sm:text-3xl font-bold mb-3">Search FastAudio</h1>
        <p className="text-muted-foreground mb-8 text-sm">
          Find guides, FAQs, and supported platforms.
        </p>

        <form
          className="flex items-center gap-2"
          onSubmit={e => e.preventDefault()}
        >
          <div className="relative flex-1">
            <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none" />
            <input
              type="search"
              value={q}
              onChange={e => setQ(e.target.value)}
              placeholder="Search…"
              className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-border bg-card text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/40 text-sm"
            />
          </div>
          <button
            type="submit"
            className="px-5 py-2.5 rounded-xl bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 transition-colors shrink-0"
          >
            Search
          </button>
        </form>

        {q && (
          <p className="mt-8 text-sm text-muted-foreground">
            No results found for <strong className="text-foreground">"{q}"</strong>.{' '}
            Try searching for "YouTube", "MP3", or "FAQ".
          </p>
        )}
      </div>
    </>
  )
}
